var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 24,
    viewBox: "0 0 8 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1v23l-4-4-4 4V1C0 .447.585-.02 1 0h6c.689-.02 1 .447 1 1z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDggMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04IDEuMDAwMDFWMjRMNCAyMEwwIDI0VjEuMDAwMDFDMCAwLjQ0NzAwOSAwLjU4NSAtMC4wMTk5OTA4IDEgOS4xODEzOWUtMDZIN0M3LjY4OSAtMC4wMTk5OTA4IDggMC40NDcwMDkgOCAxLjAwMDAxWiIgLz4KPC9zdmc+Cg==";
export { SvgBookmark as ReactComponent };